import React from 'react';
import SettingsLayout from './SettingsLayout';
import VoiceCaptureTab from '../../components/VoiceCaptureTab';

export default function SettingsVoiceCapturePage() {
    return (
        <SettingsLayout title="Voice Capture" description="Voice of the User questionnaire">
            <VoiceCaptureTab />
        </SettingsLayout>
    );
}
